export const LogoDefault = () => {
    let src;
    try {
        src = require('../assets/images/attractions/default/icon/mickey-mouse-icon.webp');
    } catch (e) {
        console.log(e);
    }
    return src;
}